// 企業・団体名
import { atom } from "recoil";
import { AtomKeys } from "../recoilKeys";

// 企業・団体名のAtom（データストア）
export const carSchoolNameState = atom<String | null>({
    key: AtomKeys.CAR_SCHOOL_NAME_STATE,
    default: null,
});
